<template>
  <v-container class='mt-5'>
      <fileUploader />
      </v-container>
</template>

<script>
import fileUploader from "../components/Upload"
export default {
    components : {fileUploader}
}
</script>

<style>

</style>